<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import type { SuggestedBrand } from '@/types/searchItemsTypes'

const emit = defineEmits<{
  (e: 'setTextFromSearchHistoryToTextArea', text: string): void
}>()

const props = defineProps<{
  autocompleteItems: string[]
  autocompleteBrandsItems: SuggestedBrand[]
}>()

const { t } = useI18n()

const autocompleteItems = computed(() => props.autocompleteItems)
const autocompleteBrandsItems = computed(() => props.autocompleteBrandsItems)

const highlightedAiTipText = computed(() => t('search.autocomplete.ai_tip'))
</script>

<template>
  <div class="search-autocomplete-inner">
    <div class="search-autocomplete-ai-tip">
      <i class="pi pi-info-circle"></i>
      <p v-html="highlightedAiTipText" class="text"></p>
    </div>

    <ul class="search-autocomplete-text-tip">
      <li
        v-for="item in autocompleteItems"
        :key="item"
        @click="emit('setTextFromSearchHistoryToTextArea', item)"
        class="text-tip body"
      >
        {{ item }}
      </li>
    </ul>

    <div v-if="autocompleteBrandsItems.length" class="search-autocomplete-brands-tip">
      <span class="brands-title title">Бренды</span>
      <div class="brands-items-list__wrapper">
        <div v-for="brandItem in autocompleteBrandsItems" :key="brandItem.brand_id" class="brands-item">
          <img
            :src="`https://static.fair.store/${brandItem?.logo_url}`"
            class="brand-image"
            alt="brand-image"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>


.search-autocomplete-inner {
  width: 100%;
  padding: 12px 8px;
  height: auto;
  max-height:210px;
  overflow-y: auto;
  margin-bottom: 12px;
}

.search-autocomplete-ai-tip {
  display: flex;
  gap: 4px;
  justify-content: flex-start;
  align-items: center;
  color: rgba(110, 133, 203, 1);
  padding: 8px 12px;
  background: rgba(216, 229, 173, 0.8);
  border-radius: 28px;
  width: 100%;
}

.search-autocomplete-text-tip {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  list-style: none;
  padding: 0;
}

.text-tip {
  padding:8px 12px;
  cursor: pointer;
}

.text-tip:hover {
  background: var(--black-10);
  border-radius: 28px;
}

.search-autocomplete-brands-tip {
  width: 100%;
}

.brands-tips {
  display: flex;
  flex-direction: column;
  gap: 12px;
  justify-content: center;
  align-items: flex-start;
  padding: 8px 0 8px 12px;
}

.brands-title {
  color: rgba(26, 33, 51, 1);
}

.history-title {
  color: rgba(26, 33, 51, 1);
}

.brands-items-list__wrapper {
  display: flex;
  gap: 24px;
  overflow: auto;
}

.brands-item {
  min-height: 96px;
  min-width: 96px;
  padding: 8px 12px 8px 12px;
  background: rgba(215, 217, 219, 1);
  border-radius: 20px;
}

.brand-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  filter: drop-shadow(0 0 5px rgba(0, 0, 0, 0.5));
  cursor: pointer;
}

.text {
  padding: 0;
  margin: 0;
}

:deep(.highlight) {
  font-weight: 600 !important;
}

</style>